import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, NgForm, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-reason-dialog',
    templateUrl: './reason-dialog.component.html',
    styleUrls: ['./reason-dialog.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, CdkTextareaAutosize, NgIf, MatError, MatDialogActions, MatButton, MatDialogClose]
})
export class ReasonDialogComponent implements OnInit {
  ngForm: NgForm;
  pauseFormGroup: UntypedFormGroup; 
  reason: string;

  constructor() {}

  ngOnInit(): void {
    this.pauseFormGroup = new UntypedFormGroup({
      reason: new UntypedFormControl('', [Validators.required])
    });
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.pauseFormGroup.controls[controlName].hasError(errorName)
  }

}
